import { render } from "./SourseInfo.vue?vue&type=template&id=10745799"
import script from "./SourseInfo.vue?vue&type=script&lang=js"
export * from "./SourseInfo.vue?vue&type=script&lang=js"

import "./SourseInfo.vue?vue&type=style&index=0&id=10745799&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__